'use client';

import useBrowser from '@/hooks/use-browser';

function FirefoxOnly({ children }) {
  const browser = useBrowser();

  if (browser !== 'firefox') {
    return null;
  }

  return children;
}

export default FirefoxOnly;
